<div class="exception-body">
    <div class="exception-wrapper notfound">
        <img src="assets/layout/images/404.png" alt="omega-layout"/>

        <p class="message-title">Page Not Found!</p>
        <p class="message-summary">The resource you are looking for does not exist.</p>

        <a href="/">
            <i class="pi pi-home"></i>
            <span>Dashboard</span>
        </a>

        <div class="login-footer">PrimeNG Omega</div>
    </div>
</div>
